import React, { useEffect, useRef, useState } from "react";
import SvgLogo from "./SvgLogo";
import { etherfiNavUrl } from "../config/logos";

const NAV_ITEMS = [
  ["Home", "home"],
  ["Manifesto", "manifesto"],
  ["Portfolio", "portfolio"],
  ["Team", "team"],
  ["News", "news"],
];

export default function NavBar({ page, go, scrolled }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const navRef = useRef(null);

  useEffect(() => {
    if (!menuOpen) return undefined;

    const handler = (e) => {
      if (e.key === "Escape") setMenuOpen(false);
    };
    const outsideHandler = (e) => {
      if (!navRef.current || navRef.current.contains(e.target)) return;
      setMenuOpen(false);
    };

    window.addEventListener("keydown", handler);
    document.addEventListener("pointerdown", outsideHandler);
    return () => {
      window.removeEventListener("keydown", handler);
      document.removeEventListener("pointerdown", outsideHandler);
    };
  }, [menuOpen]);

  const handleGo = (key) => {
    setMenuOpen(false);
    go(key);
  };

  const navLink = (label, key) => (
    <button
      key={key}
      type="button"
      className="nav-item"
      data-active={page === key}
      onClick={() => handleGo(key)}
    >
      {label}
    </button>
  );

  return (
    <nav
      ref={navRef}
      className="site-nav"
      data-menu-open={menuOpen}
      data-scrolled={scrolled}
    >
      <div className="site-nav__inner">
        <button
          type="button"
          className="site-nav__brand"
          onClick={() => handleGo("home")}
          aria-label="ether.fi Ventures home"
        >
          <SvgLogo
            url={etherfiNavUrl}
            label="ether.fi ventures"
            width="clamp(172px, 30vw, 300px)"
            height="48px"
          />
        </button>

        <button
          type="button"
          className="site-nav__toggle"
          aria-label={menuOpen ? "Close navigation" : "Open navigation"}
          aria-controls="site-nav-links"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span aria-hidden="true" />
          <span aria-hidden="true" />
          <span aria-hidden="true" />
        </button>

        <div id="site-nav-links" className="site-nav__links">
          {NAV_ITEMS.map(([label, key]) => navLink(label, key))}
          <div className="site-nav__investor-cta">
            <a
              className="site-nav__investors"
              href="/investor/"
              onClick={() => setMenuOpen(false)}
            >
              Investors
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
